module.exports = __webpack_public_path__ + "img/ar.738ab002.svg";